import { SECTION_STATUS_IN_PROGRESS, SECTION_STATUS_NOT_STARTED } from '../const';

const serializeSections = (sections, currentRoute = null) => {
  const serializedSections = sections
    .map(section => {
      const { id, title, instructions, total_time, problems, mcqs, remaining_time, status, order } =
        section;
      const type = mcqs.length > 0 ? 'mcqs' : 'problems';
      const data =
        type === 'mcqs' ? { mcqs: mcqs.map(m => m.id) } : { problems: problems.map(p => p.id) };
      return {
        id,
        instructions,
        type,
        title,
        total_time,
        remaining_time: remaining_time === null ? NaN : remaining_time,
        status,
        order,
        ...data,
      };
    })
    .sort((a, b) => a.order - b.order);
  let currentSection = null;

  // If route is provided, determine current section based on route
  if (currentRoute) {
    const problemRegex = /\/assessment\/([^\/]+)\/problem\/([^\/]+)/;
    const mcqRegex = /\/assessment\/([^\/]+)\/mcqs\/([^\/]+)/;

    const problemMatch = currentRoute.match(problemRegex);
    const mcqMatch = currentRoute.match(mcqRegex);

    if (problemMatch) {
      const problemId = problemMatch[2];
      currentSection = serializedSections.find(
        section => section.problems && section.problems.some(p => p.id === problemId),
      );
    } else if (mcqMatch) {
      const mcqId = mcqMatch[2];
      currentSection = serializedSections.find(
        section => section.mcqs && section.mcqs.some(m => m.id === mcqId),
      );
    }
  }

  // Fallback to existing logic if no route or section not found
  if (!currentSection) {
    const inProgressSection = serializedSections.find(s => s.status === SECTION_STATUS_IN_PROGRESS);
    currentSection = inProgressSection
      ? inProgressSection
      : serializedSections.find(s => s.status === SECTION_STATUS_NOT_STARTED);
  }
  return {
    sections: serializedSections,
    currentSection: currentSection,
  };
};

export default serializeSections;
